import { render, staticRenderFns } from "./NInline.vue?vue&type=template&id=809c0bd2"
import script from "./NInline.vue?vue&type=script&lang=js"
export * from "./NInline.vue?vue&type=script&lang=js"
import style0 from "./NInline.vue?vue&type=style&index=0&id=809c0bd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports